module.exports = __webpack_public_path__ + "static/media/teligentIP-newlogo.9ce62681.svg";